import { CheckIcon } from "lucide-react";

import { ContextMenuItem } from "@/components/ui/context-menu";

const NoEditInput: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  const isNoEdit = rightClickedElement.getAttribute("data-noedit");

  return (
    <>
      <ContextMenuItem
        className="flex items-center justify-between"
        onClick={() => {
          if (isNoEdit) {
            rightClickedElement.removeAttribute("data-noedit");
          } else {
            rightClickedElement.setAttribute("data-noedit", "true");
          }
        }}
      >
        بدون ویرایش
        {isNoEdit && <CheckIcon size={16} className="text-primary" />}
      </ContextMenuItem>
    </>
  );
};
export default NoEditInput;
